import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import ReactSelect from 'react-select'

import Control from './Control'
import DropdownIndicator from './DropdownIndicator'
import MenuList from './MenuList'
import Option from './Option'
import SingleValue from './SingleValue'

import './Select2.scss'

const customStyles = {
  control: () => ({}),
  valueContainer: () => ({}),
  indicatorSeparator: () => ({}),
  dropdownIndicator: () => ({}),
  menu: (style, state) => {
    const result = {}

    if (state.selectProps.menuWidth) {
      result.width = `${state.selectProps.menuWidth} !important`
    }

    if (state.selectProps.withUnderline) {
      result.borderTopLeftRadius = '0 !important'
      result.borderTopRightRadius = '0 !important'
    }

    return result
  },
  menuList: (style, state) => {
    const result = {}

    if (state.selectProps.menuHeight === 'large') {
      result.maxHeight = '21.3em'
    } else {
      result.maxHeight = '11em'
    }

    return result
  },
  option: () => ({}),
  placeholder: () => ({}),
  singleValue: (style, state) => {
    const result = {}

    if (!state.selectProps.withEllipsis) {
      result.maxWidth = 'none !important'
    }

    if (state.selectProps.isWhite) {
      result.color = 'white'
    }

    return result
  },
}

const Select2Inner = props => {
  const {
    meta: { initial },
    input: { onChange },
    isDisabled,
    isWhite,
    controlClassName,
    menuWidth,
    placeholder,
    options,
    withEllipsis,
    withRightIndent,
    withUnderline,
    skipPlaceholder,
    skipError,
    menuHeight,
    customOption,
    customSingleValue,
    isRounded,
  } = props
  const [dropdownIsOpen, openDropdownHandler] = useState(false)
  const [defaultValue, setDefaultValue] = useState(() =>
    options.find(option => option.value === initial),
  )
  const curSelectStyles = { ...customStyles }
  const Placeholder = placeholder && !skipPlaceholder && (
    <span
      className="select__placeholder"
      dangerouslySetInnerHTML={{ __html: placeholder }}
    />
  )

  const underlineClassNames = classNames({
    'select-2--disabled-underline': isDisabled,
    'select-2--invisible-underline': !withUnderline,
  })
  const wrapperClassName = classNames({
    'mt-0': skipPlaceholder,
    'mb-0': skipError,
  })
  const roundedClassName = classNames({
    'select-2--rounded': isRounded,
    'select-2--rounded-open': isRounded && dropdownIsOpen,
  })

  const onChangeHandler = next => {
    // Skip if next is empty
    if (!next || (typeof next === 'object' && next.length === 0)) {
      return
    }

    setDefaultValue(next)
    onChange(next.value)
  }

  useEffect(() => {
    setDefaultValue(options.find(option => option.value === initial))
  }, [initial, options])

  return (
    <label className={`select__wrapper ${wrapperClassName}`}>
      <ReactSelect
        styles={curSelectStyles}
        components={{
          Control,
          DropdownIndicator,
          Option: customOption || Option,
          MenuList,
          SingleValue: customSingleValue || SingleValue,
        }}
        onChange={onChangeHandler}
        classNamePrefix="select-2"
        className={`select-2 ${underlineClassNames} ${roundedClassName}`}
        defaultValue={defaultValue}
        value={defaultValue}
        placeholder=""
        options={options}
        isSearchable={false}
        isClearable={false}
        isDisabled={isDisabled}
        isWhite={isWhite}
        withRightIndent={withRightIndent}
        withEllipsis={withEllipsis}
        withUnderline={withUnderline}
        menuWidth={menuWidth}
        controlClassName={`${controlClassName} `}
        menuHeight={menuHeight}
        onMenuOpen={() => openDropdownHandler(true)}
        onMenuClose={() => openDropdownHandler(false)}
        isRounded={isRounded}
      />
      {Placeholder}
    </label>
  )
}

Select2Inner.propTypes = {
  input: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isWhite: PropTypes.bool.isRequired,
  meta: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  skipError: PropTypes.bool.isRequired,
  skipPlaceholder: PropTypes.bool.isRequired,
  withEllipsis: PropTypes.bool.isRequired,
  withRightIndent: PropTypes.number.isRequired,
  withUnderline: PropTypes.bool.isRequired,
  controlClassName: PropTypes.string,
  customOption: PropTypes.func,
  customSingleValue: PropTypes.func,
  menuHeight: PropTypes.string,
  menuWidth: PropTypes.string,
  placeholder: PropTypes.string,
  isRounded: PropTypes.bool,
}

Select2Inner.defaultProps = {
  controlClassName: '',
}

export default Select2Inner
